<template>
  <v-select
    v-model="item"
    dir="rtl"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  computed: {
    ...mapState('zirehState', { items: state => state.dietDurationPriceSelect }),
    ...mapState('zirehState', { flag: state => state.dietDurationPriceFlag }),
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setDietDurationPriceFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.dietdurationprice.getall, {},
        )
          .then(res => {
            let initData = null
            initData = res.data
            initData.forEach(item => {
              this.$set(item, 'Title', `${this.enums('DietType', 'value', item.DietType, 'text')} ${item.DietDuration.Title}`)
            })
            this.$store.commit('zirehState/setDietDurationPriceSelect', initData)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
